/* eslint @typescript-eslint/strict-boolean-expressions: off */

import cn from "classnames";
import Link from "next/link";
import React from "react";
import styles from "gui/entries/entries.module.css";
import favoriteStyles from "gui/entries/favorites.module.css";
import { formatNumber } from "lib/intl/number";
import { Avatar } from "gui/avatar/avatar";
import { EntryUser } from "lib/entries/types";
import { formatDateMY } from "lib/dates/dates";
import { Icon } from "gui/icon/icon";
import { TooltipOld } from "components/TooltipOld/TooltipOld";

interface Props {
  entry: EntryUser;
}

export const UserEntry: React.FC<Props> = (props) => {
  const user = props.entry;

  return (
    <li className={cn(styles.entry, styles.user)}>
      <div className={styles.image}>
        <Link href={`/${user.name}`}>
          <a>
            <Avatar src={user.profile_image_url} alt={user.name} size={25} />
          </a>
        </Link>
      </div>

      <div className={styles.title}>
        <Link href={`/${user.name}`}>
          <a>{user.name}</a>
        </Link>
      </div>

      <div className={styles.subtitle}>
        {user.firstQueryCreatedDate
          ? `Wizard since ${formatDateMY(user.firstQueryCreatedDate)}`
          : "No queries yet"}
      </div>

      <TooltipOld
        label={`${formatNumber(user.receivedStars)} received stars`}
        aria-label={`${user.receivedStars} received stars`}
        color="light-blue"
      >
        <div className={styles.favorites}>
          <div className={favoriteStyles.text}>
            {formatNumber(user.receivedStars)}
            <div>
              <Icon icon="star-fill" aria-label="received stars" />
            </div>
          </div>
        </div>
      </TooltipOld>
    </li>
  );
};
